<template>
  <div class="weapon-detail">
    <!-- 新样式 -->
    <div class="weapon-header">
      <div class="weapon-card">
        <img :src="weapon.imageUrl" :alt="weapon.categoryName" height="50px" class="weapon-image" />
        <!-- <div class="wuqi-top"></div> -->
        <div class="wuqi-prop">
          <div class="weapon-info">
            <h3 class="weapon-title">{{ weapon.categoryName }}</h3>
          </div>
          <div class="weapon-attributes">
            <div class="attribute-item">
              <span class="attribute-label">品质:</span>
              <span class="attribute-value">{{ weapon.quality || "无" }}</span>
              <span class="attribute-label" style="margin-left: 12px;">ST:</span>
              <span class="attribute-value">{{
                weapon.isStack == 0 ? "否" : "是"
              }}</span>
            </div>
            <div class="attribute-item">
              <span class="attribute-label">赛季:</span>
              <span class="attribute-value">{{
                weapon.description || "无"
              }}</span>
            </div>
            <!-- <div class="attribute-item sticker-container">
              <span class="attribute-label">贴纸:</span>
              <div class="sticker-list">
                <span class="attribute-value" v-if="tiezhiList.length==0">无</span>
                
                <img v-else
                  v-for="item in tiezhiList" 
                  :src="item" 
                  :key="item" 
                  :alt="weapon.categoryName" 
                  class="sticker-image"
                />
              </div>
            </div> -->
          </div>
          <div class="price-section">
            <span class="price-label">价格</span>
            <span class="price-value">￥{{ weapon.price }} </span>
          </div>
        </div>

        <div class="weapon-info">
          <!-- <h3 class="weapon-title">{{ weapon.categoryName }}</h3>
          <div class="price-section">
            <span class="price-label">价格</span>
            <span class="price-value">{{ weapon.price }} </span>
          </div> -->
        </div>
      </div>
    </div>
    <van-notice-bar left-icon="volume-o">
      <van-swipe class="notice-swipe my-swipe" :autoplay="10000" indicator-color="white" :duration="1000">
        <van-swipe-item v-for="(item, index) in noticelItems" :key="index" @click="noticeClick(item)">{{ item.title
        }}</van-swipe-item>
      </van-swipe>
    </van-notice-bar>
    <van-popup :style="{ height: '70%', width: '100%' }" v-model:show="noticeShow">
      <div v-html="noticeData"></div>
    </van-popup>
    <!-- 筛选标签 -->
    <div class="filter-tabs">
      <div class="tab-item" :class="{ active: activeTab === 'selling' }" @click="activeTab = 'selling'">
        在售
      </div>
      <div @click="getVideo()" style="
          position: absolute;
          right: 20px;
          top: 15px;
          color: #1989fa;
          text-decoration: underline;
        ">
        <van-icon size="20" name="shopping-cart-o" />如何交易？
      </div>
    </div>

    <!-- 商品列表 -->
    <van-list class="items-list" v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="item-card" v-for="item in itemsList" :key="item.categoryId">
        <div class="item-image">
          <img :src="item.imageUrl" :alt="item.categoryName" style="object-fit: contain" />
        </div>
        <div class="item-info">
          <!-- 价格和贴纸行 -->
          <div class="price-sticker-row">
            <div class="item-price">￥{{ item.price }}</div>
            <div class="sticker-info" v-if="item.stickerUrls">
              <div class="sticker-container">
                <img v-for="(sticker, index) in item.stickerUrls.split(',')" :key="index" :src="sticker"
                  :alt="item.categoryName" class="sticker-image" :title="item.categoryName" />
              </div>
            </div>
          </div>
          <div class="price-sticker-row" style="display: flex; justify-content: flex-start">
            <div class="template-wrapper" v-if="null != item.template && item.template != 0">
              <img src="@/assets/template.png" width="26px" height="16px" style="object-fit: contain" />
              <span class="template">{{ item.template || "0" }}</span>
            </div>
            <img v-if="item.isStack == '1'" src="@/assets/st.png" alt="ST" width="26px" height="16px"
              class="product-sales" />
          </div>

          <!-- 店铺信息 -->
          <div class="shop-info">
            <div class="seller-info">
              <!-- <img :src="item.sellerAvatar" :alt="item.sellerName" class="seller-avatar" /> -->
              <span class="seller-name">卖家号 {{ item.merchantId }}</span>
            </div>
            <!-- <div class="shop-rating" v-if="item.shopRating">
              <span class="star-icon">★</span>
              <span>{{ item.shopRating }}</span>
            </div> -->
          </div>
        </div>
        <div class="item-action">
          <van-button type="primary" size="small" @click="onBuyItem(item)">购买</van-button>
        </div>
      </div>
    </van-list>

    <van-dialog v-model:show="showConfirmMsgDialog" title="交易提示" show-cancel-button @confirm="handleConfirm"
      @cancel="showConfirmMsgDialog = false" confirm-button-text="继续操作" cancel-button-text="取消"
      :before-close="beforeDialogClose">
      <div class="trade-notice" style="padding: 20px 16px">
        <div class="notice-title" style="
            font-size: 18px;
            font-weight: bold;
            text-align: center;
            margin-bottom: 20px;
          ">
          商家出售饰品被脚本截胡，承担全部责任！！！
        </div>

        <div class="notice-section">
          <h3 style="font-size: 16px; margin-bottom: 10px">1、商家责任</h3>
          <van-notice-bar color="#000" background="#f5f5f5" :scrollable="false" wrapable>
            上架商品后，需要<span style="color: red">24小时</span>内进行发货商品<span style="color: red">交易被截胡、超时发货</span>扣除<span
              style="color: red">全部</span>保证金，<span style="color: red">保证金x70%</span>赔付平台，<span
              style="color: red">保证金x30%</span>赔付给买家用户，并原路退还该笔订单的全部金额给买家
          </van-notice-bar>
        </div>

        <div class="notice-section" style="margin-top: 20px">
          <h3 style="font-size: 16px; margin-bottom: 10px">2、交易纠纷</h3>
          <van-notice-bar color="#000" background="#f5f5f5" :scrollable="false" wrapable>
            双方<span style="color: red">互相督促录制</span>交易时的视频，双方有<span
              style="color: red">交易纠纷</span>时，提交给客服该视频，作为主要证据（1-3个工作日）
          </van-notice-bar>
        </div>

        <div class="checkbox-section" style="margin-top: 20px; margin-bottom: 30px">
          <van-checkbox v-model="readAndAgree" shape="square">
            我已知上述情况
          </van-checkbox>
          <van-checkbox v-model="dontShowAgain" shape="square">
            30天免提示
          </van-checkbox>
        </div>
        <van-checkbox v-model="agreeProtocol" style="margin-left: 3px">
          我已阅读并同意
          <span style="color: #1989fa" @click.stop="showProtocol">《交易支付协议》</span>
        </van-checkbox>
      </div>
    </van-dialog>

    <van-popup v-model:show="showConfirmDialog" type="dialog"
      :style="{ width: '90%', margin: 'auto', borderRadius: '12px' }">
      <div class="pay-method-container">
        <!-- 价格 -->
        <div class="price-header">
          <span class="price-text">¥ {{ shopItem.price }}</span>
        </div>

        <!-- 支付方式列表 -->
        <van-radio-group v-model="selectedPayMethod" @change="onPayMethodChange">
          <!-- 微信支付 -->
          <div class="pay-item">
            <div class="pay-icon">
              <img src="@/assets/weixin.png" alt="微信支付" />
            </div>
            <div class="pay-info">
              <div class="pay-name">微信支付</div>
              <div class="pay-desc">请在微信内打开网页支付<van-icon name="question" color="#000" size="18px" style="margin-right:4px" @click="weixinTipClick"/></div>
            </div>
            <van-radio name="wx" />
          </div>

          <!-- 支付宝支付 -->
          <div class="pay-item">
            <div class="pay-icon">
              <img src="@/assets/zhifubao.png" alt="支付宝" />
            </div>
            <div class="pay-info">
              <div class="pay-name">支付宝支付</div>
              <div class="pay-desc">请在浏览器内打开网页支付<van-icon name="question" color="#000" size="18px" style="margin-right:4px" @click="weixinTipClick"/></div>
            </div>
            <van-radio name="zfb" />
          </div>

          <!-- PP币余额 -->
          <div class="pay-item">
            <div class="pay-icon">
              <img src="@/assets/ppb.png" alt="BUFF" width="10px" height="10px" />
            </div>
            <div class="pay-info">
              <div class="pay-name">
                皮皮售余额 (¥ {{ userinfo.accountBalance }})
              </div>
              <div class="pay-desc">
                {{ userinfo.accountBalance < 0 ? "余额不足" : "" }} </div>
              </div>
              <van-radio name="ppb" />
            </div>
        </van-radio-group>

        <!-- 确认付款按钮 -->
        <div class="confirm-btn">
          <van-button type="primary" block @click="confirmPayment" :loading="showPayLoading"
            :loading-text="showPayLoadingText">
            确认付款
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-dialog v-model:show="showConfirm2Dialog" title="支付确认" show-cancel-button @confirm="confirmSubmit"
      @cancel="showConfirm2Dialog = false" confirm-button-text="确定" cancel-button-text="取消" :before-close="(action) => {
        if (action === 'confirm') {
          return true;
        }
      }
        ">
      <div style="text-align: center">
        确定支付{{ shopItem.price }} 购买饰品吗？
      </div>
    </van-dialog>

    <!-- <van-popup v-model:show="showQywxCode" position="center" :style="{ height: '80%' }" >
    <div >
        <van-image  fit="contain" :src="require('@/assets/qywx.png')" /> 
        <h2 style="text-align: center;">请您加一下我们的官方企业微信,进行交流</h2>
    </div>
  </van-popup> -->
  </div>
</template>

<script>
import request from "@/utils/request";
import { showDialog, showToast } from "vant";
export default {
  name: "WeaponDetail",
  data() {
    return {
      showPayLoading: false,
      showPayLoadingText: "",
      activeTab: "selling",
      weapon: {},
      currentPage: 0,
      itemsList: [],
      showConfirmDialog: false,
      showConfirm2Dialog: false,
      showConfirmMsgDialog: false,
      readAndAgree: false,
      dontShowAgain: false,
      agreeProtocol: false,
      showPayPwdDialog: false,
      finished: false,
      loading: false,
      shopItem: {},
      userinfo: {},
      produceId: "",
      showQywxCode: false,
      tiezhiList: [],
      noticelItems: [],
      noticeShow: false,
      noticeData: "",
      selectedPayMethod: "wx", // 默认选中网易支付
      appid: "wx7f7a74f218219cbc",
    };
  },
  async created() {
    //获取喇叭数据内容
    request.get("/front/chat/keywords", { params: { type: 2 } }).then((res) => {
      if (res.code == 200) {
        this.noticelItems = res.data;
        this.noticelItems = this.noticelItems.filter((item) => item.type == 2);
      }
    });

    this.produceId = this.$route.query.produceId;

    this.userinfo = this.$store.state.user.userInfo;

    this.getWeaponInfo(this.produceId);

    this.registerAuthCallBack();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    weixinTipClick() {
       request.get("/front/chat/keywords", { params: { type: 5 } }).then((res) => {
      if (res.code == 200) {
        this.noticeClick(res.data[0])
      }
    });
    },
    alipayTipClick() {
       request.get("/front/chat/keywords", { params: { type: 6 } }).then((res) => {
      if (res.code == 200) {
        this.noticeClick(res.data[0])
      }
    });
    },
    async registerAuthCallBack() {
      const url = new URL(window.location.href);
      const code = url.searchParams.get("code");
      const state = url.searchParams.get("state");
      console.log(`code=${code}, state=${state}`)
      if (code) {
        console.log("微信授权回调")
        try {
          // 先解码，再解析JSON
          const decodedState = decodeURIComponent(state);
          const stateData = JSON.parse(decodedState);
          console.log(stateData);
          this.weapon.categoryId = stateData.categoryId;
          this.getWeaponInfo(stateData.productId)

          const res_openid = await request.get(
            "/front/auth/wechat/auth/callback",
            {
              params: { code: code },
            }
          );
          //openid就是用户的微信id
          let openid = res_openid.data;
          this.userinfo.openId = openid;
          this.wxPayment(stateData.amount, openid, stateData.productId);
        } catch (error) {
          console.error("解析state参数失败:", error);
          this.showPayLoading = false;
          showToast("微信支付失败,请稍后重试");
        }
      }
    },

    getWeaponInfo(produceId) {
      request
        .get("/front/weapon/getWeaponInfo", {
          params: {
            productId: produceId,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.weapon = res.data.product;
            if (this.weapon.stickerUrls) {
              this.tiezhiList = this.weapon.stickerUrls.split(",");
            }
            this.currentPage = 0;
            this.onLoad();
          }
        });
    },
    // 打开支付方式选择弹窗
    openPayMethodDialog() {
      this.showPayMethodDialog = true;
    },

    // 确认付款
    async confirmPayment() {
      if (!this.selectedPayMethod) {
        this.$toast("请选择支付方式");
        return;
      }
      this.showConfirm2Dialog = true;
    },
    // 余额支付功能实现
    async ppbPay() {
      // 调用购买API
      request
        .post("/front/pay/create", {
          productId: this.shopItem.productId,
          amount: this.shopItem.price,
          payType: 3,
          payScene: 3,
        })
        .then(async (res) => {
          if (res.code == 200) {
            showToast("支付成功！");
            this.currentPage = 0;
            this.onLoad();
            // 立即刷新用户信息（包含余额）
            let ur = await this.$store.dispatch("user/getUserInfo");
            if (ur.code == 200) {
              this.userinfo = res.data;
            }
            this.$router.push("/shopHistory");
          } else {
            showToast(res.msg);
          }
        }).finally(() => {
          this.showPayLoading = false;
          this.showConfirmDialog = false;
        })
    },
    // 微信支付功能实现
    async wxPay() {
      if (this.userinfo.openId) {
        this.wxPayment(this.shopItem.price, this.userinfo.openId, this.shopItem.productId);
      } else {
        const stateData = {
          amount: this.shopItem.price,
          productId: this.shopItem.productId,
          categoryId: this.shopItem.categoryId,
        };

        // 将state数据编码为JSON字符串并进行URL编码
        const stateParam = encodeURIComponent(JSON.stringify(stateData));
        // console.log(stateParam);
        // 使用正确的重定向URL格式
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid
          }&redirect_uri=${encodeURIComponent(
            `https://www.ppstandoff2.com/weapon/${new Date().getTime()}?produceId=${this.shopItem.productId
            }`
          )}&response_type=code&scope=snsapi_base&state=${stateParam}#wechat_redirect`;
      }
    },
    isInWeixin() {
      const judgeIfWeXin = typeof WeixinJSBridge == "undefined";
      return !judgeIfWeXin;
    },
    async wxPayment(amount, openid, productId) {
      try {
        const res_createOrder = await request.post(
          "/front/pay/create",
          {
            amount: amount,
            openid: openid,
            payType: 1,
            payScene: 3,
            productId: productId,
          }
        );
        if (res_createOrder.code == 200) {
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: res_createOrder.data.payParams.appId,
              timeStamp: res_createOrder.data.payParams.timeStamp,
              nonceStr: res_createOrder.data.payParams.nonceStr,
              package: res_createOrder.data.payParams.packageVal,
              signType: res_createOrder.data.payParams.signType,
              paySign: res_createOrder.data.payParams.paySign,
            },
            async (res) => {
              if (res.err_msg === "get_brand_wcpay_request:ok") {
                showToast("支付成功");
                this.$router.push("/shopHistory");
              }
              else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                showToast("用户取消支付");
              } else {
                showToast("支付失败");
              }
            }
          );
        }
      } catch (error) {
        showToast("支付失败,请稍后重试")
      } finally {
        this.showPayLoading = false;
        this.showConfirmDialog = false;
      }
    },
    // 支付宝支付功能实现
    async zfbPay() {
      try {
        const result = await request.post("/front/pay/create", {
          amount: this.shopItem.price,
          payType: 2,
          payScene: 1,
        });
        if (result.code === 200) {
          const payFormPage = result.data.pageRedirection;
          this.handleAlipaySubmit(payFormPage);
        }
      } catch (error) {
        showToast("支付失败，请重试!");
      } finally {
        this.showPayLoading = false;
        this.showConfirmDialog = false;
      }
    },

    handleAlipaySubmit(htmlForm) {
      // 创建一个临时容器
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlForm;

      // 获取表单元素
      const form = tempDiv.querySelector("form");
      if (form) {
        // 添加到页面并提交
        document.body.appendChild(form);
        form.submit();
      } else {
        showToast("支付失败!");
      }
    },
    // 关闭弹窗
    closePayMethodDialog() {
      this.showPayMethodDialog = false;
    },
    extractAndStyleImages(htmlString) {
      // 匹配所有img标签的正则表达式
      const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/g;
      const images = [];
      let match;

      // 提取所有img标签
      while ((match = imgRegex.exec(htmlString)) !== null) {
        images.push({
          originalTag: match[0], // 原始img标签
          src: match[1], // 图片地址
          index: match.index, // 在字符串中的位置
        });
      }

      return images;
    },
    processHTMLWithStyledImages(htmlString) {
      // 提取所有图片
      const images = this.extractAndStyleImages(htmlString);
      let processedHTML = htmlString;

      // 为每个img标签添加样式
      images.forEach((img) => {
        const styledImgTag = `<img src="${img.src}" style="max-width: 100%; height: auto;" alt="饰品图片">`;
        processedHTML = processedHTML.replace(img.originalTag, styledImgTag);
      });

      return processedHTML;
    },

    noticeClick(data) {
      this.noticeData = data.content;
      this.noticeData = this.processHTMLWithStyledImages(this.noticeData);
      this.noticeShow = true;
    },
    onLoad() {
      if (!this.weapon.categoryId) {
        return false;
      }
      if (this.finished) {
        return false;
      }
      this.currentPage++;
      this.getList();
    },
    getList() {
      request
        .get("/front/weapon/getProductListByCategoryId", {
          params: {
            categoryId: this.weapon.categoryId,
            pageNum: this.currentPage,
            pageSize: 10,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (this.currentPage === 1) {
              this.itemsList = res.rows;
            } else {
              this.itemsList = [...this.itemsList, ...res.rows];
            }
            // 判断是否加载完成
            this.finished = this.itemsList.length >= res.total;
            console.log("查完数据的finished的值：", this.finished);
          }
        })
        .finally(() => {
          this.loading = false;
          // this.loading = false
        });
    },
    //提交支付
    async confirmSubmit() {
      this.showConfirm2Dialog = false;
      if ("wx" == this.selectedPayMethod) {
        if (!this.isInWeixin()) {
          showToast("请在微信内打开网页支付");
          return;
        }
        //这是微信支付的
        this.showPayLoading = true;
        this.showPayLoadingText = "正在跳转微信支付..."
        await this.wxPay();
      } else if ("zfb" == this.selectedPayMethod) {
        //这是支付宝支付的
        if (this.isInWeixin()) {
          showToast("请在浏览器内打开网页支付");
          return;
        }
        this.showPayLoading = true;
        this.showPayLoadingText = "正在跳转支付宝支付..."
        await this.zfbPay();
      } else {
        //这是余额支付的
        this.showPayLoading = true;
        this.showPayLoadingText = "正在余额支付..."
        await this.ppbPay();
      }
    },
    getTiezhiList(item) {
      return [123];
    },
    getVideo() {
      window.open("https://work.weixin.qq.com/kfid/kfc0afede0891281246");
    },
    onBuyItem(item) {
      if (!this.userinfo.username) {
        showToast("请先登录");
        this.$router.push("/profile");
        return false;
      }
      this.shopItem = Object.assign({}, item);
      if (this.userinfo.tranTipFlag == 'Y') {
         this.showConfirmMsgDialog = true;
      } else {
        this.showConfirmDialog = true;
      }
      // this.showConfirmDialog = true
    },
    beforeDialogClose(action) {
      if (action === "confirm") {
        if (!this.readAndAgree) {
          showToast("请先确认已知晓上述情况");
          return false;
        }
        if (!this.agreeProtocol) {
          showToast("请先阅读并勾选交易支付协议");
          return false;
        }

        return true;
      }
      return true;
    },
    handleConfirm() {
      if (!this.readAndAgree) {
        //如果用户没有阅读并同意协议 不允许执行后续操作
        return false;
      }
      if (!this.agreeProtocol) {
        //如果用户没有阅读并同意协议 不允许执行后续操作
        return false;
      }

      this.showConfirmDialog = true;

      if (this.dontShowAgain) {
         this.userinfo.tranTipFlag = 'N';
         request.get("/front/profile/changeTip/tranTip")
            .then(result => {
              if (result.code == 200) {
                this.userinfo.tranTipFlag = 'N'
                this.$store.commit('user/UPDATE_USER_INFO', {
                  tranTipFlag: 'N'
                })
              }
            })
      }
    },
    showProtocol() {
      showDialog({
        title: "交易支付协议",
        message: `<div class="protocol-container">
        <div class="header">
            <h1>皮皮售饰品交易回收平台出售业务服务协议</h1>
            <div class="subtitle">2025年08月5日生效版本</div>
            <p>本《皮皮售饰品交易回收平台出售业务服务协议》（下亦简称“本协议”或”皮皮售饰品交易回收平台“）的订立、履行、解释及争议的解决均适用中华人民共和国法律并排除一切冲突法的适用</p>
            <p>买卖双方注意重点关注<strong>第【三】条</strong>的交易规则</p>
            <p>协议更新时间：2025年8月5日9:00</p>
            <p>协议生效时间：2024年8月5日10:00</p>
        </div>

        <div class="important-note">
            <p>本协议约定了平台所提供的服务、平台交易规则、如何保障用户权益及纠纷的解决方式等问题。请在交易前，详细阅读本协议所有内容。如您为卖方请代入甲方条款适用，如您为买方请代入乙方条款适用，丙方为平台方。</p>
        </div>

        <p>本协议约定的交易模式为“出售）。即乙方在购买过程，可以选择支付或者取消订单。甲方知悉在通过“出售”上架饰品时，乙方可在饰品上架期间均有权选择购买该商品。</p>

        <h2>甲乙丙三方关系说明：</h2>

        <h3>【甲方】</h3>
        <p>是指自愿签署《出售业务服务协议》，且已阅览并同意本协议所有条款，认可本协议的法律效力，认同丙方平台的商业模式，通过丙方运营平台出售商品或饰品的用户。</p>

        <h3>【乙方】</h3>
        <p>是指自愿签署《出售业务服务协议》，且已阅览并同意本协议所有条款，认可本协议的法律效力，认同丙方平台的商业模式，通过丙方运营平台下单购买甲方商品的用户。</p>

        <h3>【丙方】</h3>
        <p>是负责为本协议项下的出售服务提供系统支持及信息技术支持等服务的网络交易平台，是为甲乙双方提供技术和服务支持的在线交易平台，该平台名为“皮皮售饰品交易回收平台”由台州市范成电子商务有限公司开发运营。</p>

        <div class="important-note">
            <h3>特别提醒：</h3>
            <p>1、在此特别提示您阅读本协议的各个条款，尤其是以粗体、下划线等标识的条款，包括但不限于<strong>第【三】条违约的处理</strong>、<strong>第【十】条争议解决条款</strong>、<strong>第【十一】条合同效力</strong>、<strong>第【十二】条通知及送达条款</strong>及附件-《个人信息查询授权书》等可能限制或影响您责任的相关条款。甲方及丙方通过本协议向乙方提供出售服务，如乙方通过点击确认、勾选同意等方式在平台或其他客户端确认本协议，或通过电子签名的方式在电子合同平台签署本协议，即视为乙方已阅读并同意本协议所有条款，且对本协议条款的含义及相应的法律后果已全部通晓并充分理解，同意接受本协议的约束。</p>

            <p>2、甲方确认并承诺：甲方已明确知晓使用皮皮售饰品交易回收平台的交易规则，同意并认可出售的饰品“出售”的交易模式；丙方按照本协议约定向乙方主张相关权益时，如需甲方配合，甲方应予以积极配合；</p>

            <p>3、乙方确认并承诺：乙方已明确知晓乙方登陆皮皮售饰品交易回收平台前已同意授权皮皮售饰品交易回收获取乙方的支付宝账号信息，使用该支付宝账号在皮皮售饰品交易回收平台进行的任意行为均视为乙方本人的行为，乙方对上述行为承担一切责任及法律后果；乙方同意并认可购买出售的饰品“出售”的交易模式。</p>

            <p>4、如果您不同意本协议的任意内容，或者无法准确理解本协议相关条款，请不要进行后续操作。如您对本协议有任何疑问，确认签署本协议之前请联系平台官方客服进行咨询，皮皮售饰品交易回收客服将竭诚为您服务并作出解释。</p>

            <p>5、丙方运营皮皮售饰品交易回收平台、H5页面、显示的商品或服务信息随时都可能发生变动，丙方运营皮皮售饰品交易回收平台的网站、小程序、H5页面中的文字表述、图片效果可能被实时修改和调整，对于此类变化和调整，丙方可能无法及时做特别通知。丙方运营皮皮售饰品交易回收平台的网站内展示的标的物规格、参数、库存等商品信息将尽可能准确、详细并与实际产品信息相匹配，但由于网站上商品信息的数量极其庞大，且受互联网技术发展水平（如网络延迟、设备配置）等因素的限制，丙方运营皮皮售饰品交易回收平台的网站、H5页面等不排除部分信息会存在滞后或差错的可能性。甲方、乙方确认：对此情形您表示知悉并理解，并同意不追究丙方的相关责任。</p>

            <p>6.本协议签订于台州市范成电子商务有限公司办公地点。如各方就本协议的内容或其执行发生任何争议（包括但不限于协议或者其他财产性权益纠纷），各方应友好协商解决；协商不成时，各方同意交由本协议签订地有管辖权的人民法院管辖并处理。</p>
        </div>

        <h2>一、定义或名词解释</h2>

        <div class="definition-list">
            <dl>
                <dt>1.1、Standoff2中文名全称《对峙2》（下文称为对峙2）</dt>
                <dd>是由俄罗斯公司ALEXT公司开发的第一人称射击游戏。</dd>

                <dt>1.2、饰品</dt>
                <dd>是指对峙2游戏内所存在的、可在对峙2内的不同账号之间流转的游戏资源、游戏道具等可归属于特定主体的财产或财产性权益（包括但不限于游戏中的武器、装备、皮肤等），在本协议中，也可用"商品"来指代饰品，在饰品上架后期间，丙方用商品来指代饰品。</dd>
                <dd>本协议以及皮皮售饰品交易回收平台相关页面中所描述的"售卖"、"出售"、"售"、"购买"、 "上架"等用词，均指且仅指前述财产或财产性权益及其交易对价在特定主体之间的流转行为。</dd>

                <dt>1.3、截胡</dt>
                <dd>是指甲方和乙方之间进行饰品交易期间， 出现甲方商品在交易时出现失误没有准确无误的转移到乙方手中</dd>

                <dt>1.4、交易失败</dt>
                <dd>是指甲方和乙方交易期间商品出现了"超时"，"截胡"，"货不对板"等没有成功到账的情况统称为交易失败</dd>
            </dl>
        </div>

        <h2>二、关于商品</h2>

        <p>2.1、本协议所称商品是指用户通过皮皮售饰品交易回收发布出售的游戏装备等虚拟物品，也称饰品。</p>

        <p>2.2、乙方在下单购买商品前应当向丙方提供自己的真实姓名和身份证号码，同时还应当提供准确的联系地址及联系方式（包括但不限于手机号码、微信、钉钉、邮箱等），该联系方式适用于第十二条所列内容。乙方联系方式及地址变更须及时通知丙方，否则视为未予变更，由此导致的一切损失，应由乙方承担。</p>

        <p>2.3、甲方在交货商品过程中，需确保商品完好，所有权无争议，未经乙方同意，不得对交货中的商品有以下行为：包括但不限于更改游戏道具名称、属性、外观、功能改变等破坏商品的行为，商品必须安全</p>

        <p>2.4、饰品上架，甲方上架饰品过程中，为了方便，甲方可以免费使用丙方为提高定价效率所提供的定价手段，上架的饰品定价均需要甲方再次核对确认。</p>
        <p>甲乙双方完成交易后，若甲方认为交易商品价格不符合预期，由甲方自行承担，甲方确认丙方不因提供方便甲方定价的手段而承担责任。</p>

        <p>出于保障乙方用户正常商品购买的权利，甲方上架时填写的价格金额需要保证其合理性，若甲方存在恶意定价扰乱市场的情况，丙方有权利封禁甲方账户部分交易权限。</p>

        <p>2.5、丙方所提供的饰品、商品检视图效果仅供参考，商品交付的实际样式以对峙2游戏内呈现为准，乙方予以确认。</p>

        <p>甲乙双方完成交易后，若乙方发现交易商品在对峙2游戏中的样式与丙方提供该商品的上架商品存在差异，由甲乙双方协商解决，丙方可视情况决定是否居中协调，甲乙双方认可丙方不因此承担任何责任，即确认丙方选择做协调工作也并不意味丙方需要承担责任。</p>

        <h2>三、交易规则</h2>

        <p>3.1、鉴于皮皮售饰品交易回收平台仅为一个基于互联网的交易平台，台州市范成电子商务有限公司并不参与用户之间的磋商、付款、交付等交易环节。用户确认并同意后再创建，皮皮售饰品交易回收平台的预估价、参考价、市场价等，仅仅是台州市范成电子商务有限公司为了更好地服务用户而提供给用户的参考信息，任何时候任何情况下，台州市范成电子商务有限公司的上述行为均不得被认为是对交易标的价格的合理性、交易标的来源的合法性等进行的任何明示或默示的担保或保证。</p>
        <p>出于保障用户的合法权益之必要，用户均同意授权台州市范成电子商务有限公司根据本协议约定及皮皮售饰品交易回收平台规则对发生在皮皮售饰品交易回收平台上的交易进行监管，用户对台州市范成电子商务有限公司据此进行的审查、调查、限制、处罚、责任追究等予以认可。</p>

        <p>3.2、针对甲方上架商品时需缴纳3%此商品金额的保证金 当乙方购买后，甲方订单交易"发货超时（超过24小时）"、"商品被截胡"，丙方扣除甲方保证金x70%赔付给甲方平台，甲方保证金x30%赔付给乙方用户 并记作"超时发货1次"</p>
        <p>当甲方向乙方发货时，双方应该需同时录制交易视频，双方后续发生争议可依靠双方视频就行判断决策</p>
        <p>当甲方未成功发货或该商品因甲方原因"失误"，"看走眼"等截胡导致乙方未能获得该商品，甲方需承担该商品的所有丢失责任，皮皮售饰品交易回收平台有权将全部商品金额原路退还给乙方。</p>
        <p>若此次丢件有关甲方和乙方产生的任何纠纷，首先由双方协商解决，若双方不能达成共识，可申请丙方予以协助，丙方将按照本协议约定及出售物详情页中的相关规定进行判定，如果本协议约定及出售物详情页中的相关规定不能解决相关问题，则丙方将依据一般人的认知程度对该争议进行判断和处理。双方对丙方的判断和处理不服的，双方可另行通过法律途径解决。</p>

        <p>3.3、若用户账户被盗、遭遇黑客攻击或出现其他异常情形的，在用户向台州市范成电子商务有限公司提出或台州市范成电子商务有限公司主动发现异常的情况下，为保护用户合法权益，台州市范成电子商务有限公司有权就用户账户及交易展开调查，并对用户的账户采取保护性的处理措施，包括但不限于暂时限制账户操作、皮皮售饰品交易回收平台使用权限降级（包括但不限于限制提现、出售、购买、饰品、商品检视、昵称修改等）、资金冻结、中止或终止交易、撤销交易等。</p>

        <p>3.4、交易完成后，若经任何第三方举报或台州市范成电子商务有限公司主动发现交易异常的情形下，台州市范成电子商务有限公司有权对已完成交易展开调查，若经调查发现已完成交易确属违反法律法规或本协议，台州市范成电子商务有限公司将有权撤销该交易，在用户的皮皮售饰品交易回收平台账户余额中扣除等额的交易款项、限制或禁止用户使用皮皮售饰品交易回收平台账户、限制或禁止用户提取皮皮售饰品交易回收平台账户余额等。</p>

        <p>3.5、您应知悉，由于网络服务的特性和复杂性，台州市范成电子商务有限公司可能难以及时发现用户账户或交易的异常情况，故为保障您的合法权益，请密切关注您的账户和交易情况，一旦发生异常请及时与台州市范成电子商务有限公司联系。</p>

        <p>3.6、商品（包含印花）交货成功时，系统将自动验货，若发现当前商品的印花信息与创建订单时的商品快照（即商品详情总览）不一致的，会将订单进入到延时结算，并向乙方发送通知，乙方可自行在游戏中验货，在延时结算状态下，可联系客服介入请求部分退款，超过2个小时（即延时阶段状态为两小时内）乙方未联系，视为乙方确认无误，资金自动结算给甲方；</p>

        <h2>四、支付方式</h2>

        <p>丙方提供包括支付宝、微信、皮皮售饰品交易回收钱包余额、等支付方式。</p>
        <p>为了确保交易安全，维护交易规则，订单中涉及到的交易款项，甲方和乙方均同意由丙方代收代付。</p>

        <h2>五、甲方权利与义务</h2>

        <p>5.1、甲方保证所出售的商品享有法律上完整的所有权、处分权。保证没有任何权属瑕疵及其他法律纠纷。因甲方出售商品的所有权瑕疵或纠纷，导致乙方在收取商品后产生争议或纠纷，甲方需配合乙方处理并赔偿给乙方带来的损失。</p>

        <p>5.2、甲方应按乙方订单要求发货，确保商品信息与订单中标明的一致，并有权按照出售服务协议订单显示价格收取相应的售价。</p>

        <p>5.3、乙方收货后，在使用商品过程中造成人身损害、财产损失的，甲方不承担任何责任。</p>

        <p>5.4、丙方按照本协议约定向乙方主张权益时，如需甲方配合，甲方应予以积极配合。</p>

        <h2>六、乙方权利与义务</h2>

        <p>6.1、乙方在出售完成后拥有购买商品的合法所有权、使用权，乙方需合理使用该商品。</p>

        <p>6.2、按本出售服务协议的约定按时、足额向甲方支付售价并且及时收货。</p>

        <p>6.3、乙方须是具有完全民事行为能力的成年人，乙方使用购买商品时应遵守相关法律、法规，合理合法使用购买的商品。不得利用购买的商品从事违法犯罪活动，不得利用购买的商品侵害他人合法权益；因乙方违规使用购买的商品所产生的一切法律纠纷及法律责任由乙方自行解决、承担。</p>

        <h2>七、丙方权利与义务</h2>

        <p>7.1、丙方承诺不泄漏甲方、乙方在丙方留存的账户及个人身份信息。</p>

        <p>7.2、乙方在使用购买商品过程中造成人身损害、财产损失的，由乙方自行承担，丙方对乙方的损害和损失不承担任何责任。</p>

        <p>7.3、丙方对甲乙双方之间的出售服务业务有监督的权限，对甲乙双方的投诉应及时协调和处理。</p>

        <h2>第八条 责任限制</h2>

        <p>8.1、丙方对不可抗力导致的损失不承担责任。本协议所指不可抗力包括：天灾、法律法规、政府指令的变更、第三方应用平台原因、因网络服务特性而特有的原因（例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、突发性的软硬件设备及电子通信设备故障、互联网覆盖范围限制、计算机病毒、黑客攻击等因素等），及其他合法范围内的不能预见、不能避免并不能克服的客观情况。</p>

        <p>8.2、甲乙双方理解并同意，丙方的服务是按照现有技术和条件所能达到的现状提供的。丙方会尽最大努力向您提供服务，确保服务的连贯性和安全性；但丙方不能随时预见和防范技术风险以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、第三方服务干涉、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。丙方不能确保您从皮皮售饰品交易回收平台下载的任何资料或其他数据无病毒、无污染或不具破坏性。</p>
        <p>由于网络环境特殊性及网络第三方不确定安全因素，丙方不承诺皮皮售饰品交易回收平台或皮皮售饰品交易回收平台的任何内容、服务或功能无任何错误或不中断，不承诺任何瑕疵将被纠正，或者您对皮皮售饰品交易回收平台的使用将产生特定结果。</p>
        <p>如果对皮皮售饰品交易回收平台或任何内容有任何不满意，您应当停止使用皮皮售饰品交易回收平台或任何该等内容。</p>

        <p>8.3 对发生下列情形造成的不便或损害，丙方不承担责任：</p>
        <p>(1)为了更好地为用户提供专业、便捷的服务而进行的网站和服务器的定期检查或施工、更新软硬件而造成的服务中断；</p>
        <p>(2)网络服务提供商线路或其他故障；</p>
        <p>(3)在紧急情况之下依照法律的规定或政府部门的指令而采取的措施；</p>
        <p>(4)用户与其它任何第三方的纠纷；</p>
        <p>(5)丙方根据已经生效的法律文书以及有效政府文件的要求进行的任何操作；</p>
        <p>(6)其他非丙方原因导致的情形。</p>

        <p>8.4、鉴于交易标的的特殊性，皮皮售饰品交易回收平台无法鉴别和判断相关交易各主体之民事行为能力、资质、信用等状况，也无法鉴别和判断交易标的之来源、权属、真伪、性能、规格、质量、数量等属性及状况。因此，您在交易前应加以仔细辨明，并慎重考虑和评估交易可能产生的各项风险并自行承担由此带来的后果。</p>

        <h2>第九条 隐私条款</h2>

        <p>9.1 本协议所指的"隐私"包括《电信和互联网用户个人信息保护规定》第4条规定的用户个人信息的内容以及未来不时制定或修订的法律法规中明确规定的隐私应包括的内容。</p>

        <p>9.2 当甲乙双方注册皮皮售饰品交易回收个人账户并接受使用平台出售服务时，甲乙双方须向丙方提供必要个人信息。丙方收集个人信息的目的是为用户提供尽可能多的个人服务以及风险评估，从而更好的为乙方提供出售服务，在此过程中，丙方承诺不会泄露甲乙双方个人信息。</p>

        <p>9.3 丙方不会在未经合法用户授权时，公开、编辑或透露其个人信息及保存在丙方中的非公开内容，除非有下列情况:</p>
        <p>(1)事先获得用户的明确授权。</p>
        <p>(2)根据有关的法律法规要求。</p>
        <p>(3)按照相关政府主管部门或有关司法机关的要求。</p>
        <p>(4)丙方维护自身权益的需要。</p>

        <h2>第十条 争议解决</h2>

        <p>因本协议履行过程中引起的或与本协议相关的任何争议，三方应以友好协商的方式解决，若经协商仍未解决，三方均应向本协议签订地有管辖权的人民法院提起诉讼解决，守约方为实现债权所产生的案件受理费、诉讼保全费、公告费、公证费、律师费、差旅行费等一切费用由违约方承担。</p>

        <h2>第十一条 合同效力</h2>

        <p>11.1、本协议自乙方在确认订单页点击勾选本协议，且提交订单成功，合同成立且生效。</p>

        <p>11.2、本协议有效期自乙方下单购买支付成功且商品最终到达乙方库存内之日止。</p>

        <p>11.3、乙方下单网页页面、甲方发货凭证、交易快照等均是本协议附件，与本协议有同等法律效力。若记载内容存在冲突，以丙方运营后台记载的信息为准。</p>

        <h2>第十二条 通知和修订</h2>

        <p>12.1、 丙方为了更好的服务甲乙双方，随着业务发展及政策变化，本协议可能随之修改和更新。丙方更新本协议时，需在生效前，通过在皮皮售饰品交易回收网站、皮皮售饰品交易回收移动端公告或其他适当方式提醒甲乙双方相关内容的修改和更新。</p>

        <p>12.2 、本协议履行过程中，丙方发送给甲方、乙方的书面通知，书面通知的形式包括但不限于甲方或丙方采用平台公告、平台站内信息、APP弹窗推送、发送电子邮件、手机短信、电话、钉钉、微信等现代化电子通讯方式。以邮寄送达的，按照甲方、乙方填写的送达地址。自书面通知交邮后的第五个自然日视为送达；在采用上述电子方式进行书面通知的情况下发送当日即视为送达。</p>

        <p>12.3 、丙方有权决定以前述任何一种或几种形式书面通知用户。丙方以多种方式向用户发送通知的，通知送达时间以最先送达的为准。</p>

        <p>12.4、甲方、乙方通讯地址和通讯方式默认为甲乙双方在丙方平台注册和交易时提供电话号码、电子邮箱及送达地址。甲方、乙方同意，默认通讯方式可以适用于司法送达。</p>

        <p>12.5、如果甲乙双方上述送达地址有变更本人应当及时告知丙方和司法机关变更后的送达地址。</p>

        <p>12.6、甲方和乙方承诺，已完全阅读所有条款，并保证上述送达地址是准确的、有效的；如果提供的送达地址不准确，或不及时告知变更后的地址，使法律文书无法送达或未及时送达，由甲方和乙方自行承担由此产生的一切法律后果。</p>

        <p>12.7、若发生纠纷(包括但不限于交货产品交货成功后发现严重破损或与创单的交易快照不符、差距过大等)，为保证依法依约提起诉讼主张权利的诉讼文书及时、准确送达给甲方乙方，甲方、乙方确认的送达地址、系本人真实意思表示。甲方、乙方确认的上述地址不真实、不准确(包括但不限于地名变更、地址被拆迁、确认的地址中无人签收文书等情形)，导致人民法院的相关文书未能实际由本人签收，视同已收到人民法院寄送的相关文书。邮件退回之日，视为送达之日。</p>
        <p>如人民法院等司法机关使用电子送达，向甲方、乙方预留电话号发送电子送达信息之日视为送达之日。</p>
        <p>甲方、乙方均承诺如变更上述送达地址、电话的，将在5个工作日内书面或邮件通知更改送达地址；若因未及时书面通知和更改确认书，导致人民法院的相关文书未能实际由本人签收，将视同本人已收到人民法院寄送的相关文书。邮件退回之日、信息发送之日视为送达之日。甲方、乙方对人民法院寄送的相关文书、电子送达的信息，应诚实收取；若人民法院按上述地址寄送相关文书，收件人拒绝签收或因其他不可抗力的任何原因导致相关文书退回的，将视同本人已收到人民法院寄送的相关文书。邮件退回之日，视同送达之日。</p>

        <h2>第十三条</h2>

        <p>甲乙丙三方承诺，已完全阅读所有条款，并保证已理解上述条款的准确意义，由本协议产生的法律后果各方自愿承担。</p>

        <h2>附件一: 个人信息查询授权书</h2>

        <div class="important-note">
            <p>[特别提示]本授权书以数字电文形式签订，在签订授权书之前，请申请人务必仔细阅读本授权书的全部条款，关注您在授权书中的权利和义务。授权人(即申请人)本人同意并不可撤销地授权皮皮售饰品交易回收平台，在本次购买过程中(自购买下单至购买订单完结结束)，基于约定用途:包括但不限于担保或依法或经有权部门要求等，有权通过第三方服务机构( 包括但不限于中国人民征信中心等第三方权威征信机构、第三方服务机构及其关联公司以及第三方数据机构等)对申请人提交的个人信息进行核实，有权通过前述第三方服务机构采集申请人的运营商信息、借贷信息、消费信息、财务信息等个人信息(包括可能对本人产生负面影响的不良信息)用于为申请人提供风控、出售、购买、出售交易过程管理等金融服务。申请人已被明确告知提供上述信息可能 会给本人带来经济、声誉损失等不利后果，但本人仍然同意授权查询主体通过第三方服务机构采集相关信息。授权人本人同意并不可撤销地授权皮皮售饰品交易回收平台向第三方服务机构提供个人信息及借贷信息(含办理业务时产生的不良信息)以判断、识别业务风000000000000000000000000000000务机构依 据法律法规就授权范围内对上述本人信息进行采集、获取、存储、处理、提供、传输、披露。授权人本人同意并授权甲方及丙方将本人个人信息及履约情况提供给包括但不限于金融信用信息基础数据库、中国人民银行批准成立的征信机构、政府公共信用信息平台、银行、非银行金融机构、电信运营商、征信公司、甲方及丙方的关联公司及合作机构等，以供有关单位、部门及个人查询和使用。授权人本人承诺本授权效力具有独立性，不因其他合同的任何条款无效而无效。 授权人本人已知悉本授权书所有内容的意义及由此产生的法律效力，自愿作出上述授权，本授权申明是授权人本人真实的意思表示，本人同意承担由此带来的一切法律后果。</p>
            <p>特此授权!</p>
        </div>

        <div class="footer">
            <p>台州市范成电子商务有限公司</p>
            <p>皮皮售饰品交易回收平台</p>
            <p>2025年8月5日</p>
        </div>
    </div>`,
        messageAlign: "left",
        scrollable: true,
        maxHeight: "90vh",
        allowHtml: true,
        // confirmButtonText: '我已阅读并同意',
        showCancelButton: false,
      });
    },
  },
};
</script>

<style scoped>
.weapon-detail {
  background-color: #f7f8fa;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 武器头部区域 */
/* .weapon-header {
  background: white;
  margin-bottom: 8px;
  padding: 10px;
  //display: flex;
} */

/* 武器主图 */

.weapon-main-image img {
  max-width: 40%;
  max-height: 40%;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/* 武器基本信息 */
.weapon-basic-info {
  padding: 16px;
  border-bottom: 1px solid #ebedf0;
}

/* .weapon-title {
  font-size: 18px;
  font-weight: 600;
  color: #323233;
  margin: 0 0 8px 0;
  line-height: 1.4;
} */

.weapon-meta-row {
  display: flex;
  /* justify-content: space-between; */
  /* align-items: center; */
  margin-bottom: 8px;
}

.weapon-category {
  font-size: 14px;
  color: #969799;
}

.price-info {
  display: flex;
  align-items: center;
  gap: 6px;
}

.current-price {
  font-size: 20px;
  font-weight: 600;
  color: #ee0a24;
}

/* 统计信息 */
.weapon-stats {
  display: flex;
  padding: 16px;
}

.stat-item {
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-number {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  line-height: 1.2;
}

.stat-label {
  font-size: 12px;
  color: #969799;
  margin-top: 2px;
}

/* 筛选标签 */
.filter-tabs {
  background: white;
  display: flex;
  padding: 0 16px;
  margin-bottom: 8px;
  overflow-x: auto;
  position: relative;
}

.tab-item {
  padding: 12px 16px;
  font-size: 14px;
  color: #969799;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
  white-space: nowrap;
  flex-shrink: 0;
}

.tab-item.active {
  color: #1989fa;
  border-bottom-color: #1989fa;
}

/* 排序区域 */
.sort-section {
  background: white;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ebedf0;
  margin-bottom: 8px;
}

.sort-left {
  display: flex;
  align-items: center;
}

.sort-label {
  font-size: 14px;
  color: #323233;
  margin-right: 4px;
}

.sort-icon {
  font-size: 12px;
  color: #969799;
}

.result-count {
  font-size: 12px;
  color: #969799;
}

/* 商品列表 */
.items-list {
  flex: 1;
  background: white;
  overflow-y: auto;
  /* 自定义滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
  /* 为webkit浏览器设置滚动条样式 */
}

.items-list::-webkit-scrollbar {
  width: 6px;
}

.items-list::-webkit-scrollbar-track {
  background: transparent;
}

.items-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.items-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.item-card {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #ebedf0;
  justify-content: space-between;
}

.item-image {
  width: 60px;
  height: 40px;
  margin-right: 12px;
  border-radius: 4px;
  overflow: hidden;
  background: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item-info {
  /* flex: 1; */
  margin-right: 12px;
}

.item-price {
  font-size: 16px;
  font-weight: 600;
  color: #ee0a24;
  margin-bottom: 6px;
  margin-right: 5px;
}

.item-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.item-id {
  font-size: 12px;
  color: #969799;
  min-width: 80px;
}

.wear-section {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wear-bar {
  width: 40px;
  height: 4px;
  background: #ebedf0;
  border-radius: 2px;
  overflow: hidden;
}

.wear-progress {
  height: 100%;
  background: linear-gradient(90deg, #52c41a 0%, #faad14 50%, #ff4d4f 100%);
  transition: width 0.3s;
}

.wear-value {
  font-size: 11px;
  color: #969799;
}

.item-stats {
  display: flex;
  gap: 1px;
}

.stat-icon {
  font-size: 10px;
  color: #ffd700;
}

.item-action {
  flex-shrink: 0;
}

/* 响应式优化 */
@media (max-width: 375px) {
  .weapon-basic-info {
    padding: 12px;
  }

  .weapon-title {
    font-size: 16px;
  }

  .current-price {
    font-size: 18px;
  }

  .weapon-stats {
    padding: 12px;
  }

  .stat-number {
    font-size: 14px;
  }

  .item-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  /* 价格和贴纸行 */
  .price-sticker-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
  }

  .item-price {
    font-size: 16px;
    font-weight: 600;
    color: #ee0a24;
  }

  .sticker-info {
    display: flex;
    align-items: center;
  }

  .sticker-count {
    font-size: 12px;
    color: #1989fa;
    background: #e8f3ff;
    padding: 2px 6px;
    border-radius: 10px;
    border: 1px solid #1989fa;
  }

  /* 店铺信息 */
  .shop-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }

  .shop-name {
    font-size: 13px;
    color: #646566;
    font-weight: 500;
  }

  .shop-rating {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #ffa500;
  }

  .star-icon {
    font-size: 10px;
    margin-right: 2px;
    color: #ffa500;
  }
}

/* 店铺信息 */
.shop-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.seller-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.seller-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #ebedf0;
}

.seller-name {
  font-size: 13px;
  color: #646566;
  font-weight: 500;
}

.shop-rating {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #ffa500;
}

.star-icon {
  font-size: 10px;
  margin-right: 2px;
  color: #ffa500;
}

/* 价格和贴纸行 */
.price-sticker-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.item-price {
  font-size: 16px;
  font-weight: 600;
  color: #ee0a24;
}

.sticker-info {
  display: flex;
  align-items: center;
}

/* .sticker-container {
  display: flex;
  gap: 4px;
  align-items: center;
} */

/* .sticker-image {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  object-fit: cover;
  border: 1px solid #e8e8e8;
  background: #f5f5f5;
} */

/* 店铺信息 */
.shop-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.seller-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.seller-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #ebedf0;
}

.seller-name {
  font-size: 13px;
  color: #646566;
  font-weight: 500;
}

.shop-rating {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #ffa500;
}

.star-icon {
  font-size: 10px;
  margin-right: 2px;
  color: #ffa500;
}

.template-wrapper {
  /* position: relative; */
  display: inline-flex;
  align-items: center;
  margin-right: 5px;
}

.template {
  /* position: absolute; */
  /* left: 45%; */
  /* top: 70%; */
  transform: translate(-20%, 0%);
  /* color: black; */
  font-size: 10px;
  font-weight: bold;
  /* text-shadow: 0 0 2px rgba(0,0,0,0.5); */
}

/* 新样式 */
.weapon-header {
  padding: 8px 12px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  height: auto;
  min-height: 120px;
}

.weapon-card {
  display: flex;
  height: 100%;
  align-items: center;
  flex-direction: row;
  gap: 12px;
}

.wuqi-top {
  height: 50px;
  display: flex;
}

.weapon-image-container {
  /* width: 40%;
  display: flex;
  align-items: center;
  justify-content: center; */
  /* background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */
  /* border-radius: 8px;
  padding: 16px; */
  /* height: 50px; */
}

.weapon-image {
  width: 100px;
  height: 40px;
  object-fit: contain;
}

.weapon-info {
  display: flex;
  flex-direction: column;
}

.weapon-title {
  margin: 0;
  font-size: 14px;
  /* color: #1989fa; */
  /* color: #25293e; */
  /* color: orange; */
  /* line-height: 1.4; */
}

.wuqi-prop {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 6px;
}

.weapon-attributes {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.attribute-item {
  display: flex;
  align-items: center;
  gap: 2px;
}

.attribute-label {
  min-width: 36px;
  color: #969799;
  font-size: 11px;
}

.attribute-value {
  color: #969799;
  font-size: 11px;
}

.sticker-container {
  /* align-items: flex-start; */
}

.sticker-list {
  display: flex;
  /* gap: 8px; */
  flex-wrap: wrap;
}

.sticker-image {
  width: 20px;
  height: 20px;
  object-fit: cover;
  border-radius: 4px;
  /* border: 1px solid #323233;  */
}

.price-section {
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.price-label {
  color: #969799;
  font-size: 11px;
}

.price-value {
  color: #ee0a24;
  font-size: 18px;
  font-weight: bold;
}

.trade-notice {
  max-height: 70vh;
  overflow-y: auto;
}

.notice-section {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.checkbox-section {
  display: flex;
  justify-content: space-around;
}

.my-swipe .van-swipe-item {
  width: 100%;
  text-decoration: underline;
}

.pay-method-container {
  padding: 20px;
  background: white;
  border-radius: 12px;
}

.price-header {
  text-align: center;
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
}

.pay-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.pay-item:last-child {
  border-bottom: none;
}

.pay-item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pay-icon {
  width: 40px;
  height: 40px;
  /* border-radius: 50%; */
  overflow: hidden;
  /* background: #f5f5f5; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.pay-info {
  flex: 1;
  margin-left: 12px;
}

.pay-name {
  font-size: 16px;
  color: #333;
}

.pay-desc {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.confirm-btn {
  margin-top: 20px;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  color: white;
  font-size: 14px;
}
</style>